export default __webpack_public_path__ + "static/media/ig_orange.b6dc7121.png";